import { $ } from '@starberry/components';
import * as UserObjectActions from 'core/services/store/userobject/actions';
import UserObjectServices from 'core/services/store/userobject/services';

const Wishlist = {
  $: 'PropertyResults',

  template: {
    $: 'PropertyItem',
    provide: ['userobject'],
    onDelete: () => (_, context) => (e) => {
      const [, dispatch] = context?.state?.userobject || [];
      UserObjectServices(dispatch, UserObjectActions).deleteUserObject('savedProperties', {
        id: context.data.userobject.id,
      });
      e.stopPropagation();
      e.preventDefault();
    },
    props: {
      showRooms: true,
      showPrice: true,
    },
  },

  container: {
    $: 'Grid',
    props: {
      flex: 1,
      templateColumns: ({ data }) =>
        !data?.length
          ? '1fr'
          : {
              base: '1fr',
              md: `repeat(2, minmax(0, 1fr))`,
              xl: `repeat(3, minmax(0, 1fr))`,
            },
      gap: 10,
    },
  },

  props: {
    config: (props) => ({
      data: 'state.userobject.0.savedProperties',
      provide: ['userobject'],
      limit: props.limit,
      container: props.container,
      template: props.template,
      loading: {
        $: 'Center',
        props: {
          p: 50,
        },
        children: [{ $: 'Spinner', props: { size: 'lg' } }],
      },
      empty: {
        $: 'NoContentAvailable',
        icon: 'saveProperty',
        heading: $(
          'constants.translations.wishList.NO_SAVED_PROP_TITLE',
          'There are no saved properties'
        ),
        description: $(
          'constants.translations.wishList.NO_SAVED_PROP_SUBTITLE',
          'Search the property and add it in your favorite list'
        ),
      },
    }),
  },
};

export default Wishlist;
